import ko from 'knockout';
import { computed, shallowRef } from 'vue-demi';

const localTkoSocket = ko.observable();
const localVueSocket = shallowRef();

export function setSocket(socket) {
  localTkoSocket(socket);
  localVueSocket.value = socket;
}

export const tkoSocket = ko.pureComputed(() => localTkoSocket());
export const tkoSocketId = ko.pureComputed(() => tkoSocket()?.io.engine.id);

export const vueSocket = computed(() => localVueSocket.value);

// Retrieves the correct socket URL based from the account object.
export function getSocketUrl(account) {
  return account?.environment.serviceUrls.notificationServer;
}
